import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import { formatMoneda } from "../../util/varios";
import moment from "moment";
import useTableFijo from "../useTableFijo";
import ModalAgregarEgresoEnviar from "./agregarEgresoEnviarDespacho";
import { DangerButton, PrimaryButton, SuccessButton } from "../../ui/buttons/Button";
import { Input } from "../../ui/inputs/Input";

export const ModalEnviarEgresoDespacho = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° Egreso",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Banco",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto",
      textAlign: "center",
    },
  ];

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState("hidden");
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("hola papa");
  const [mostrar5, setMostrar5] = useState(false);

  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [codigo, setCodigo] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtObservacion = useRef();
  const txtCodigo = useRef();

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTableFijo(
    records,
    headCells,
    filterFn,
    220
  );

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      setBody({
        operacion: operacion,
        nid: txtCodigo.current.value !== "" ? txtCodigo.current.value : 0,
        fec: txtFecha.current.value,
        obser: txtObservacion.current.value,
        depart: 6,
        idefi: idefiscal,
        devol: "0",
        aprob: true,
        detalles: records,
      });
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Aprobar estos Documentos?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/actuchequeteso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Orden de Pago Aprobada Correctamente",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();
    setValues(item);
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setRecords([]);
    setVisible("hidden");
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setTitulo("");
    setActivo(true);
  };

  const opciones = (ope, index) => (event) => {
    event.preventDefault();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else {
      let array = records;
      let array2 = [];
      for (let i = 0; i < array.length; i++) {
        if (array[i].idchequeemitido !== values.idchequeemitido) {
          array2.push(array[i]);
        }
      }
      setRecords(array2);
    }
  };
  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
  };

  function verificarExistencia(idchequeemitido, array) {
    return array.some((item) => item.idchequeemitido === idchequeemitido);
  }

  const agregarOrdenPago = (values) => {
    setMostrar5(false);
    const idExiste = verificarExistencia(values.idchequeemitido, records);
    if (!idExiste) {
      records.push(values);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Ya esta orden de pago fue agregada.",
        icono: "informacion",
      });
    }
  };
  const seleccionarRegistro = (id) => {
    let endpoint = `${op.conexion}/api/administracion/detallecheques?id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          seleccionarRegistro(props.egreso.idaprobacionescheque);
          txtCodigo.current.value = props.egreso
            ? props.egreso.idaprobacionescheque
            : "";
          txtFecha.current.value = props.egreso
            ? moment.utc(props.egreso.fecha).format("YYYY-MM-DD")
            : "";
          txtObservacion.current.value = props.egreso
            ? props.egreso.observaciones
            : "";
        } else {
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Enviar Egreso a Tesoreria</h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div
          
          className="col-12 border-azul rounded p-2 m-0 d-flex flex-wrap justify-content-between"
        >
          <div className="col-4 col-lg-2 m-0 p-0">
            <Input label = "Código"
              name="observacion"
              disabled={true}
              id="inputDireccion"
              ref={txtCodigo}
            />
          </div>

          <div className="col-6 col-lg-4 m-0 p-0">
            <Input label = "Fecha:"
              type="date"
              disabled
              defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
              id="inputDireccion"
              ref={txtFecha}
            />
          </div>
          <div className="col-12 p-0 m-0 my-2">
            <Input label = "Observación:"
              name="observacion"
              onChange={onChange}
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              id="inputDireccion"
              ref={txtObservacion}
            />
          </div>

          <div className="col-11 m-0 p-0">
            <TblContainer
              container={{ height: 250, width: "100%", overflow: "auto" }}
            >
              <TblHead />
              <tbody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr
                      key={item + item.numerocheque}
                      className="table-bordered"
                      disabled={operacion === 1 ? false : true}
                      style={{
                        padding: "0",
                        cursor: "pointer",
                        background:
                          values.numerocheque === item.numerocheque
                            ? "lightskyblue"
                            : "white",
                      }}
                      onClick={seleccionarFila(item)}
                    >
                      <td style={{ fontSize: "10px", textAlign: "center" }}>
                        {item.numerocheque}
                      </td>
                      {operacion === 1 ? (
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {item.portador}
                        </td>
                      ) : (
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {item.banco}
                        </td>
                      )}
                      <td
                        style={{
                          fontSize: "10px",
                          textAlign: "right",
                          width: "150px",
                        }}
                      >
                        {formatMoneda(
                          item.montocheque
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
          </div>
          <div className="col-1 m-0 p-0 pl-2 d-flex flex-column justify-content-center align-items-center gap-2">
            <PrimaryButton icon = 'fa-plus m-0' 
                disabled={operacion === 1 ? false : true}
                onClick={opciones(1, "")}
            >
            </PrimaryButton>
            <DangerButton icon = 'fa-trash-alt m-0'
              disabled={operacion === 1 ? false : true}
              onClick={opciones(3, "")}
            >
            </DangerButton>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton onClick={onChangeValidar}>Aceptar</SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <ModalAgregarEgresoEnviar
        show={mostrar5}
        onHideCancela={() => {
          setMostrar5(false);
        }}
        onHideAceptaCatalogo={agregarOrdenPago}
      />
    </Modal>
  );
};
